import { LitElement as c, unsafeCSS as f } from "lit";
import { property as t } from "lit/decorators.js";
import y from "../../shared/reset.style.css.js";
import { booleanType as n } from "../../utils/property-types.js";
import d from "./button.style.css.js";
import { template as h } from "./button.template.js";
var m = Object.defineProperty, e = (l, i, r, p) => {
  for (var s = void 0, a = l.length - 1, u; a >= 0; a--)
    (u = l[a]) && (s = u(i, r, s) || s);
  return s && m(i, r, s), s;
};
class o extends c {
  constructor() {
    super(...arguments), this.type = "button", this.variant = "primary", this.status = "default", this.label = "", this.icon = void 0, this.iconPosition = "left", this.disabled = !1, this.hidden = !1, this.onlyIcon = !1, this.fullWidth = !1, this.size = "md", this.tooltipFixed = !1, this.loading = !1, this.forceViewport = !1, this.tooltipPosition = "top", this.loadingIcon = "progress_activity";
  }
  static get styles() {
    return [f(y), f(d)];
  }
  _handleClick() {
    if (this.disabled || this.loading) return;
    const i = this.closest("form");
    this.type === "submit" && i ? i.requestSubmit() : this.type === "reset" && i && i.reset(), this.dispatchEvent(new CustomEvent("onClick", { bubbles: !0, composed: !0 }));
  }
  _getIconSize() {
    return this.size === "lg" ? "md" : "sm";
  }
  checkTextTruncate(i) {
    if (!i) return;
    const r = i.target;
    let p = !1;
    if (this.onlyIcon)
      p = !0;
    else {
      const s = r.querySelector(".dss-button-text");
      p = s.scrollWidth > s.offsetWidth;
    }
    r.setAttribute("data-truncated", p.toString());
  }
  focus(i) {
    var s;
    const r = (s = this.shadowRoot) == null ? void 0 : s.querySelector(".dss-button");
    if (!r) return;
    const p = { ...i, focusVisible: !0 };
    r.focus(p);
  }
  render() {
    return h(this);
  }
}
e([
  t({ type: String })
], o.prototype, "type");
e([
  t({ type: String })
], o.prototype, "variant");
e([
  t({ type: String })
], o.prototype, "status");
e([
  t({ type: String })
], o.prototype, "label");
e([
  t({ type: String })
], o.prototype, "icon");
e([
  t({ type: String })
], o.prototype, "iconPosition");
e([
  t(n)
], o.prototype, "disabled");
e([
  t(n)
], o.prototype, "hidden");
e([
  t(n)
], o.prototype, "onlyIcon");
e([
  t(n)
], o.prototype, "fullWidth");
e([
  t({ type: String })
], o.prototype, "size");
e([
  t(n)
], o.prototype, "tooltipFixed");
e([
  t(n)
], o.prototype, "loading");
e([
  t(n)
], o.prototype, "forceViewport");
e([
  t({ type: String })
], o.prototype, "tooltipPosition");
export {
  o as Button
};
//# sourceMappingURL=button.js.map
